
import { supabase } from '../../integrations/supabase/client';

export const signInWithCredentials = async (email: string, password: string) => {
  const { error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) throw error;
  return;
};

export const signInWithGoogle = async (redirectPath?: string) => {
  const safe = redirectPath && redirectPath.startsWith('/') && !redirectPath.startsWith('//')
    ? redirectPath
    : null;
  try {
    if (safe) {
      sessionStorage.setItem('auth_redirect_path', safe);
    } else {
      sessionStorage.removeItem('auth_redirect_path');
    }
  } catch (_) { /* ignore storage errors */ }
  const callback = `${window.location.origin}/auth/callback${safe ? `?redirect=${encodeURIComponent(safe)}` : ''}`;
  console.log(callback);
  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: callback,
    },
  });

  if (error) throw error;
  return;
};

export const signUpWithCredentials = async (email: string, password: string, fullName: string) => {
  const { error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        full_name: fullName,
      },
    },
  });

  if (error) throw error;
  return;
};

export const signOutUser = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
  return;
};

export const checkAdminRole = async () => {
  const { data, error } = await supabase.rpc('has_role', { _role: 'admin' });
  
  if (error) {
    console.error('Error checking admin role:', error);
    return false;
  }
  
  return !!data;
};

export const resetPassword = async (email: string) => {
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/auth?reset=true`,
  });

  if (error) throw error;
  return;
};
